import { gql } from "@apollo/client"
import SCHEDULED_ACTION_FRAGMENT from "./scheduledAction"
import SESSION_FRAGMENT from "./session"

const EVENT_FRAGMENT = gql`
  ${SCHEDULED_ACTION_FRAGMENT}
  ${SESSION_FRAGMENT}

  fragment EventFragment on Event {
    id
    title
    description
    start_date
    end_date
    event_setup_completed
    max_bookings_per_student
    max_bookings_restricted_days
    vc_auto_disconnect
    open_parents
    open_staff
    disable_parent_bookings
    client_id
    created_at

    scheduledActions {
      ...ScheduledActionFields
    }

    user {
      id
      name
      email
    }
    
    meetingTypes {
      id
      name
      type
    }

    sessions {
      ...SessionFields

      groups {
        id
        title
        user_id
      }
    }
  }
`

export default EVENT_FRAGMENT